var isV3SingleInput = function (params) {
    var _a;
    return (_a = (params && 'params_tuple' in params && 'sqrtPriceLimitX96' in params['params_tuple'])) !== null && _a !== void 0 ? _a : false;
};
export var getMethodName = function (_a) {
    var isExactInput = _a.isExactInput, isInputNative = _a.isInputNative, isOutputNative = _a.isOutputNative, protocol = _a.protocol, params = _a.params;
    if (protocol === 'V2') {
        if (isExactInput) {
            if (isInputNative) {
                return 'swapExactETHForTokens';
            }
            if (isOutputNative) {
                return 'swapExactTokensForETH';
            }
            return 'swapExactTokensForTokens';
        }
        if (isInputNative) {
            return 'swapETHForExactTokens';
        }
        if (isOutputNative) {
            return 'swapTokensForExactETH';
        }
        return 'swapTokensForExactTokens';
    }
    if (protocol === 'V3') {
        if (isExactInput) {
            // Only "single" methods have this param
            if (isV3SingleInput(params)) {
                return 'exactInputSingle';
            }
            return 'exactInput';
        }
        if (isV3SingleInput(params)) {
            return 'exactOutputSingle';
        }
        return 'exactOutput';
    }
    throw new Error('Invalid protocol');
};
// | 'swapExactTokensForTokensSupportingFeeOnTransferTokens'
// | 'swapTokensForExactTokens'
// | 'swapETHForExactTokens'
// | 'swapExactETHForTokensSupportingFeeOnTransferTokens'
// | 'swapExactTokensForETHSupportingFeeOnTransferTokens'
// | 'swapTokensForExactETH',
export var getExactInputFeeMethodNameV2 = function (_a) {
    var isInputNative = _a.isInputNative, isOutputNative = _a.isOutputNative;
    if (isInputNative) {
        return 'swapExactETHForTokensSupportingFeeOnTransferTokens';
    }
    if (isOutputNative) {
        return 'swapExactTokensForETHSupportingFeeOnTransferTokens';
    }
    return 'swapExactTokensForTokensSupportingFeeOnTransferTokens';
};
